import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import u from 'umbrellajs';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import { Sortable } from '@shopify/draggable';
import { isEqual } from 'lodash';
import _e from 'common/localeUtil';
import WidgetsDragDrop from '../WidgetsDragDrop';
import {
	checkElement2,
	checkWindowVariableChangedToTrue,
	findGrapesJSComponent,
	generateWidgetsInHTML,
	getWidgetsFromHTML,
	usePrevious
} from '../../utils';

const useStyles = makeStyles(() => ({
	dialogContent: {
		padding: '0 !important'
	}
}));

const AddWidgetsDialogDragDrop = ({ open, handleClose, widgetContainerId, ...props }) => {
	const classes = useStyles();
	const [widgets, setWidgets] = useState([]);
	const prevWidgets = usePrevious(widgets);
	const addDragDropForSection = sectionSelector => {
		// Make sections draggable
		const drag = new Sortable(document.querySelectorAll(sectionSelector), {
			draggable: '.each-section-link',
			handle: '.movebar-title'
		});
		drag.on('sortable:stop', () => {
			// console.log('sortable:stop', e);
			checkElement2(`${sectionSelector}:not([class^="draggable"])`).then(() => {
				let i = 0;
				u(`${sectionSelector} .each-section-link`).each(node => {
					const sectionID = u(node).data('section-id');
					// console.log(sectionID, u(node).attr('class'));
					const aComp = findGrapesJSComponent(`${sectionID}`);
					if (aComp) {
						i += 1;
						aComp.setStyle({
							...aComp.getStyle(),
							order: i
						});
						// Set order of menu too
						let comp = findGrapesJSComponent(`a[href="${sectionID}"]`);
						if (comp) {
							comp = comp.parent();
							if (comp) {
								comp.setStyle({
									...comp.getStyle(),
									order: i
								});
							}
						}
					}
				});
			});
		});
		document.ontouchmove = function(event) {
			event.preventDefault();
		};
	};

	useEffect(() => {
		checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
			console.log('checkWindowVariableChangedToTrue once');
			if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
				const widgetsIds = getWidgetsFromHTML();
				setWidgets(widgetsIds);
				// console.log('generateSections widgets', widgetsIds);
			}
		});
		checkElement2('.section-content').then(() => {
			addDragDropForSection('.section-content');
		});
	}, []);

	useEffect(() => {
		if (!prevWidgets) return;
		if (!isEqual(prevWidgets, widgets)) {
			console.log('Use effect update wdigets', widgets);
			checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
				// console.log('checkWindowVariableChangedToTrue');
				if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
					console.log(
						'EditorLeftPanelSections generateWidgetsInHTML',
						prevWidgets,
						widgets
					);
					generateWidgetsInHTML(widgets);
				}
			});
		}
	});

	const handleRemoveClickCallback = widgetId => () => {
		const newWidgets = widgets.filter(widget => widget !== widgetId);
		console.log('handleRemoveClickCallback', widgetId, newWidgets);
		setWidgets(newWidgets);
	};

	const onDragDropCallback = selectedWidgetIds => {
		console.log('onDragDropCallback');
		setWidgets(selectedWidgetIds);
	};

	const handleAddClickCallback = widgetId => () => {
		const newWidgets = [...widgets, widgetId];
		const currentWidgetId = widgetContainerId ? widgetContainerId.substring(1) : null;
		if (currentWidgetId) {
			const widgetIndex = newWidgets.findIndex(item => item === currentWidgetId);
			console.log(currentWidgetId, widgetIndex);
			if (widgetIndex >= 0) {
				newWidgets.splice(widgetIndex, 1);
			}
		}
		console.log('handleAddClickCallback', widgetId, newWidgets);
		setWidgets(newWidgets);
		setTimeout(handleClose, 500);
	};

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="simple-dialog-title"
			open={open}
			fullWidth
			maxWidth={'md'}
			className="dialog"
		>
			<DialogTitle id="simple-dialog-title">
				<div className="dialogTitle">
					<div>
						<div className="dialogTitleText">{_e('widget')}</div>
						<div className="dialogSubtitleText">
							<Typography variant="body1">{_e('widget_desc')}</Typography>
						</div>
					</div>
					<div>
						{handleClose && (
							<IconButton onClick={handleClose}>
								<Close />
							</IconButton>
						)}
					</div>
				</div>
			</DialogTitle>
			<DialogContent className={`dialogContent ${classes.dialogContent}`}>
				<WidgetsDragDrop
					widgetContainerId={widgetContainerId}
					onDragDropCallback={onDragDropCallback}
					handleRemoveClickCallback={handleRemoveClickCallback}
					handleAddClickCallback={handleAddClickCallback}
					selectedWidgetIds={widgets}
					{...props}
				/>
			</DialogContent>
		</Dialog>
	);
};

AddWidgetsDialogDragDrop.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	widgetContainerId: PropTypes.string
};

export default AddWidgetsDialogDragDrop;
